//////////////////////////////////////////////////////////////////////////////////////////////////////
// 1.0 - Add to cart
//////////////////////////////////////////////////////////////////////////////////////////////////////
const axiosAddItmesToCart = async (products, nonce, action) => {
  grecaptcha.ready(async () => {
    const token = await grecaptcha.execute(localData.captchaSiteKey, { action: 'addItemsToCart' });
    const formDataInput = new FormData();
    formDataInput.append('action', 'addItemsToCart');
    formDataInput.append('nonce', nonce);
    formDataInput.append('nonce_action', action);
    formDataInput.append('products', JSON.stringify(products));
    formDataInput.append('lang', localData.lang);
    formDataInput.append('id', localData.id);
    formDataInput.append('token', token);
    axios
      .post(localData.apiURL, formDataInput, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        return;
      });
  });
};

//////////////////////////////////////////////////////////////////////////////////////////////////////
// 2.0 - Remove form cart
//////////////////////////////////////////////////////////////////////////////////////////////////////
const axiosRemoveItmesFromCart = async (products, nonce, action) => {
  const callAxios = new Promise((resolve, reject) => {
    grecaptcha.ready(async () => {
      const token = await grecaptcha.execute(localData.captchaSiteKey, { action: 'removeItemsFromCart' });
      const formDataInput = new FormData();
      formDataInput.append('action', 'removeItemsFromCart');
      formDataInput.append('nonce', nonce);
      formDataInput.append('nonce_action', action);
      formDataInput.append('products', JSON.stringify(products));
      formDataInput.append('lang', localData.lang);
      formDataInput.append('id', localData.id);
      formDataInput.append('token', token);
      const response = await axios.post(localData.apiURL, formDataInput, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return resolve(response.data.data);
    });
  });
  return callAxios;
};

//////////////////////////////////////////////////////////////////////////////////////////////////////
// 3.0 - Update cart
//////////////////////////////////////////////////////////////////////////////////////////////////////
const updateItemsQuantityInCart = async (products, nonce) => {
  const callAxios = new Promise((resolve, reject) => {
    grecaptcha.ready(async () => {
      const token = await grecaptcha.execute(localData.captchaSiteKey, { action: 'updateItemQuantityInCart' });
      const formDataInput = new FormData();
      formDataInput.append('action', 'updateItemQuantityInCart');
      formDataInput.append('nonce', nonce);
      formDataInput.append('products', JSON.stringify(products));
      formDataInput.append('lang', localData.lang);
      formDataInput.append('id', localData.id);
      formDataInput.append('token', token);
      const response = await axios.post(localData.apiURL, formDataInput, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return resolve(response.data.data);
    });
  });
  return callAxios;
};

//////////////////////////////////////////////////////////////////////////////////////////////////////
// 4.0 - Cookie
//////////////////////////////////////////////////////////////////////////////////////////////////////
// function to store cookies
function setCookie(cName, cValue) {
  const date = new Date();
  date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${cName}=${cValue};${expires};path=/`;
}

// function to check if cookie exists, if exists return json object, if not return null
function getCookie(cName) {
  const name = `${cName}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return JSON.parse(c.substring(name.length, c.length));
    }
  }
  return null;
}

// function to delete cookie
function deleteCookie(cName) {
  document.cookie = `${cName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////
// 5.0 - Get shipping cost
//////////////////////////////////////////////////////////////////////////////////////////////////////

const getShippingCost = (zip) => {
  grecaptcha.ready(async () => {
    const token = await grecaptcha.execute(localData.captchaSiteKey, { action: 'getShippingCost' });
    const formDataInput = new FormData();
    formDataInput.append('action', 'getShippingCost');
    formDataInput.append('zip', zip);
    formDataInput.append('lang', localData.lang);
    formDataInput.append('id', localData.id);
    formDataInput.append('token', token);

    const wrapper = document.querySelector('.summary-box__inner');
    const submitBtn = wrapper.querySelector('.btn');
    submitBtn.classList.toggle('is-disabled', true);
    submitBtn.style.pointerEvents = 'none';

    const response = await axios.post(localData.apiURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    if (response.status === 200) {
      document.querySelector('.summary-box__row--delivery').innerHTML = response.data.data.delivery_html;
      document.querySelector('.summary-box__row--final-amount').innerHTML = response.data.data.amount_html;
    }

    submitBtn.classList.toggle('is-disabled', false);
    submitBtn.style.pointerEvents = '';
  });
};
